import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FAT_SOLUBLE_VITAMIN_TYPE,
  WATER_SOLUBLE_VITAMIN_TYPE,
  propertySaveService,
} from '../../../services/propertySaveService'
import RadioLabel from '../../RadioLabel'
import Switch from '../../../shared/Switch'
import PropertyItemVitaminTypeError from './PropertyItemVitaminTypeError'
import { ADD_PRODUCT_MICRO_ELEMENTS } from '../../helper'

type VitaminSolubilityType =
  | typeof WATER_SOLUBLE_VITAMIN_TYPE
  | typeof FAT_SOLUBLE_VITAMIN_TYPE

const PropertyItemVitaminSlider = () => {
  const { i18n } = useTranslation()
  const [isVitamin, setIsVitamin] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [isWaterSoluble, setIsWaterSoluble] = useState(false)

  const createVitaminTypeLabelName = (vitaminType: VitaminSolubilityType) =>
    i18n.t(`app.page.product.propertyItem.${vitaminType}`)

  const changePropertyData = () => {
    setIsVitamin(!isVitamin)
    propertySaveService.updatePropertyValue('isVitamin', !isVitamin)
  }

  const changePropertyIsVitaminState = (
    value: boolean,
    type: VitaminSolubilityType,
  ) => {
    setIsWaterSoluble(type === WATER_SOLUBLE_VITAMIN_TYPE ? value : !value)
    propertySaveService.changeVitaminType(
      type === WATER_SOLUBLE_VITAMIN_TYPE ? value : !value,
    )
  }

  const openVitaminsType = () => {
    const property = propertySaveService.getProperty()
    setIsVitamin(Boolean(property.isVitamin))
    setIsVisible(property.categoryName === ADD_PRODUCT_MICRO_ELEMENTS)
    setIsWaterSoluble(Boolean(property.isWaterSoluble))
  }

  useEffect(() => {
    openVitaminsType()
    propertySaveService.registerItemUpdateObserver(openVitaminsType)
    return () =>
      propertySaveService.unRegisterItemUpdateObserver(openVitaminsType)
  }, [])

  if (!isVisible) {
    return null
  }

  return (
    <>
      <label className="block__text product__form-label_inline">
        <Switch value={isVitamin} changeIsVitaminValue={changePropertyData} />
        <span className="product__form-label_text">
          {i18n.t('app.page.product.propertyItem.vitamin')}
        </span>
      </label>
      {isVitamin ? (
        <label className="block__text product__form-label product__form-item">
          <span className="product__form-label_text">
            {i18n.t('app.page.product.propertyItem.type')}
          </span>
          <RadioLabel
            value={isWaterSoluble === true}
            type={WATER_SOLUBLE_VITAMIN_TYPE}
            title={createVitaminTypeLabelName(WATER_SOLUBLE_VITAMIN_TYPE)}
            changeValue={changePropertyIsVitaminState}
          />
          <RadioLabel
            value={isWaterSoluble === false}
            type={FAT_SOLUBLE_VITAMIN_TYPE}
            title={createVitaminTypeLabelName(FAT_SOLUBLE_VITAMIN_TYPE)}
            changeValue={changePropertyIsVitaminState}
          />
        </label>
      ) : null}
      {isVitamin &&
      propertySaveService.getProperty().isWaterSoluble === undefined ? (
        <PropertyItemVitaminTypeError />
      ) : null}
    </>
  )
}

export default PropertyItemVitaminSlider
